import React from "react";
import { Grid } from "@mui/material";
import { Loading } from "../../components/sharedComponents/Loading";
import { ContentPanel } from "../../components/user/contentPanel/ContentPanel";
import { useAuth } from "../../context/AuthContext";

const UserDashboard = () => {
  const { token, user, loading } = useAuth();
  return (
    <Grid
      container
      style={{
        height: "100vh",
        width: "100vw",
        margin: 0,
        padding: 0,
        overflow: "hidden",
      }}
    >
      {loading ? (
        <Loading message="Cargando Información de Usuario..." />
      ) : (
        <>
          <ContentPanel token={token} userMe={user} />
        </>
      )}
    </Grid>
  );
};

export default UserDashboard;
